<script lang="ts">
	//Formatters
	import { format } from 'svelte-i18n';
	//Helpers
	import { real_id } from '../../../../helpers/interface_helpers';
	import { onSettingsResponse } from '../../../../helpers/device_settings_helpers';
	//Services
	import { postReq } from '../../../../services/http';
	//Stores
	import { getDeviceStatus, readDeviceSettings } from 'src/stores/device-runtime/status-selectors';
	//Design system components
	import { Checkbox, Button } from '@Shelly/shelly-design-system';
	//Types
	import type { Device } from '../../../../types/Device';
	export let device: Device;

	const id = real_id(device.id),
		settings = readDeviceSettings(id);
	let checked = settings.lux_wakeup_enable,
		waitForResponse = false;

	const save = async () => {
		waitForResponse = true;
		const res = await postReq(`/device/generic_command`, {
			id,
			command: `set`,
			payload: `{"lux_wakeup_enable":${Number(checked)}}`,
		});
		onSettingsResponse(res, device);
		waitForResponse = false;
	};
</script>

<Checkbox size="m" bind:checked class="mb-s" id="checkbox-81bxioy"
	>{$format('wake_up_by_lighting_enable', {
		default: 'Enable device wake up when lighting changes.',
	})}</Checkbox
>

<Button size="m" class="text-uppercase" width="full" loading={waitForResponse} on:click={save}
	>{$format('button_apply', { default: 'apply' })}</Button
>
